import React from "react";
import { useDispatch } from "react-redux";
import { RoomLinkIcn } from "graphics/icons/Space/SpaceIcons";
import { setRoomLinkModal } from "slices/textSlice";
import EfsTippy from "components/HOCS/EfsTippy";

const RoomLink = () => {
  const dispatch = useDispatch();

  return (
    <EfsTippy
      content="Share a Link for Guests"
      placement="top"
      className="normal-Tippy grey-Tippy"
      delay={[0, 0]}
    >
      <button
        className="room-link"
        onClick={() => dispatch(setRoomLinkModal(true))}
      >
        <span className="icon">
          <RoomLinkIcn />
        </span>
        <span className="texty">Share Link</span>
      </button>
    </EfsTippy>
  );
};

export default RoomLink;
